import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppraisalSectionViewProps } from ".";
import { AMOUNT_UTIL } from "../../../../../../utils/amount.utils";

const BreackDownSection = (props: AppraisalSectionViewProps) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <p className="blue-text description">{t("Appraisal.breackdownDes")}</p>

            {props.data?.breakdown_of_funding_and_benefits && props.data?.breakdown_of_funding_and_benefits.map((item, index) => (
                <div className="form-list-item-wrapper" key={index} >
                    <Form.Item
                        label={item.breakdown_of_funding_and_benefit_type?.name}>
                        <div className="item-group">
                            {
                                item.details && item.details.map((d, i) => (
                                    <Row key={i}>
                                        <Col span={16}>
                                            <span >
                                                {d.description}
                                            </span>
                                        </Col>
                                        <Col span={8}>
                                            {AMOUNT_UTIL.convertNumericToFormattedAmount(d.value)}
                                        </Col>
                                    </Row>

                                ))
                            }
                            <Form.Item>
                                <span>
                                    {item.notes}
                                </span>
                            </Form.Item>
                        </div>

                    </Form.Item>


                </div>

            ))}

            <Row gutter={[16, 32]}>
                <Col span={16} className="total-text">
                    {t("Appraisal.lbNetCashInflow")}
                </Col>
                <Col span={8} className="green-text">
                    {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.annual_total)}
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={16} className="total-text">
                    {t("Appraisal.lbNetCashOutflow")}
                </Col>
                <Col span={8} className="red-text">
                    {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.annual_total)}
                </Col>
            </Row>


        </div >
    )
}

export default BreackDownSection;